import { gql } from '@apollo/client';
import { POSITION_DETAIL_FIELDS } from '../position/positionDetail.fields';
import { JOB_FIELDS } from './job.fields';

export const JOB_DETAIL_FIELDS = gql`
  ${JOB_FIELDS}
  ${POSITION_DETAIL_FIELDS}
  fragment JobDetailFields on Job {
    ...JobFields
    positions {
      ...PositionDetailFields
    }
  }
`;
